/**
 * Directed-graph helpers for workflow builder loop UX.
 */

function buildAdjacency(edges) {
  const children = {}
  const parents = {}

  for (const edge of edges || []) {
    if (!edge?.source || !edge?.target) continue
    if (!children[edge.source]) children[edge.source] = []
    if (!parents[edge.target]) parents[edge.target] = []
    children[edge.source].push(edge.target)
    parents[edge.target].push(edge.source)
  }

  return { children, parents }
}

/**
 * True when walking forward from nodeId can reach nodeId again (directed cycle).
 */
export function nodeParticipatesInDirectedCycle(nodeId, edges) {
  if (!nodeId) return false

  const { children } = buildAdjacency(edges)
  const startChildren = children[nodeId] || []
  if (startChildren.length === 0) return false

  const visited = new Set()
  const stack = [...startChildren]

  while (stack.length > 0) {
    const current = stack.pop()
    if (current === nodeId) return true
    if (visited.has(current)) continue
    visited.add(current)
    for (const next of children[current] || []) {
      stack.push(next)
    }
  }

  return false
}

/**
 * True when this node is on a cycle, or has an ancestor that is on a cycle
 * (sibling/off-cycle nodes that re-fire when a looping parent repeats).
 */
export function shouldOfferAllowMultipleTaskInstances(nodeId, edges) {
  if (!nodeId) return false
  if (nodeParticipatesInDirectedCycle(nodeId, edges)) return true

  const { parents } = buildAdjacency(edges)
  const queue = [...(parents[nodeId] || [])]
  const seen = new Set()

  while (queue.length > 0) {
    const parentId = queue.shift()
    if (!parentId || seen.has(parentId)) continue
    seen.add(parentId)
    if (nodeParticipatesInDirectedCycle(parentId, edges)) return true
    for (const grandparent of parents[parentId] || []) {
      queue.push(grandparent)
    }
  }

  return false
}
